import { Button, Form } from "antd";
import type { Rule } from "antd/lib/form";
import type { Moment } from "moment";
import type { ReactNode } from "react";

type Props<T> = {
  name: string;
  initialValue: T;
  rules?: Rule[];
  onFinish: (value: T) => void;
  onReset?: () => void;
  children: ReactNode;
  dataTest?: string;
};

export function AttributeEditForm<
  T extends string | number | Moment | undefined | null
>({
  name,
  initialValue,
  rules,
  onFinish,
  onReset,
  children,
  dataTest,
}: Props<T>) {
  const [form] = Form.useForm();

  const handleFinish = (values: { [key: string]: T }) => {
    onFinish(values[name]);
  };

  const handleReset = () => {
    form.resetFields();
    onReset?.();
  };

  return (
    <Form
      form={form}
      initialValues={{ [name]: initialValue }}
      onFinish={handleFinish}
      onReset={handleReset}
      data-test={dataTest}
    >
      <Form.Item name={name} rules={rules} className="mb-1">
        {children}
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
        <Button htmlType="reset" className="ml-2">
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
}
